import List from '@/pages/admin/imports/List.vue';
import New from '@/pages/admin/imports/New.vue';
import handlePaginationRouteProps from '@/utils/handlePaginationRouteProps.js';

export default [
  {
    path: 'imports',
    name: 'imports',
    component: List,
    props: handlePaginationRouteProps,
  },
  {
    path: 'imports/new',
    name: 'imports-new',
    component: New,
  },
];
